module.exports = __webpack_public_path__ + "static/media/needle.cd68cb16.svg";